import React, { useState, useContext, useEffect } from 'react';
import styled from 'styled-components';
import { useDebounce } from 'hooks';
import { Form, InputNew, LabelWrapper, Text } from 'components';
import { SectionContainer } from './StyledComponents';
import { ERROR_MESSAGES } from '../constants';
import FormContext from '../FormContext';

const ForwardCalls = () => {
  const {
    frontDeskValidState,
    userState,
    setUserState,
    userStateDirty,
    setUserStateDirty,
    setWorking,
  } = useContext(FormContext);

  const [name, setName] = useState(
    userState?.frontEndInstructions?.forwardCalls?.name || '',
  );
  const [phone, setPhone] = useState(
    userState?.frontEndInstructions?.forwardCalls?.phone || '',
  );
  // Fields updates are debounced to improve performance so state validation doesn't occur on every character change
  const debouncedName = useDebounce(name, 500);
  const debouncedPhone = useDebounce(phone, 500);

  const handleNameChange: React.ChangeEventHandler<HTMLInputElement> = e => {
    const newName = e.target.value;
    setWorking(true);
    setName(newName);
  };

  useEffect(() => {
    setUserState(prev => {
      const copy = { ...prev };
      copy.frontEndInstructions = {
        ...copy.frontEndInstructions,
        forwardCalls: {
          ...copy.frontEndInstructions?.forwardCalls,
          name: debouncedName,
        },
      };
      return copy;
    });
    setWorking(false);
  }, [debouncedName, setUserState, setWorking]);

  useEffect(() => {
    setUserState(prev => {
      const copy = { ...prev };
      copy.frontEndInstructions = {
        ...copy.frontEndInstructions,
        forwardCalls: {
          ...copy.frontEndInstructions?.forwardCalls,
          name: debouncedName,
        },
      };
      return copy;
    });
    setWorking(false);
  }, [debouncedName, setUserState, setWorking]);

  useEffect(() => {
    setUserState(prev => {
      const copy = { ...prev };
      copy.frontEndInstructions = {
        ...copy.frontEndInstructions,
        forwardCalls: {
          ...copy.frontEndInstructions.forwardCalls,
          phone: debouncedPhone,
        },
      };
      return copy;
    });
    setWorking(false);
  }, [debouncedPhone, setUserState, setWorking]);

  const handleNumberChange: React.ChangeEventHandler<HTMLInputElement> = e => {
    const newPhone = e.target.value;
    setPhone(newPhone);
  };

  const displayInvalidPhone =
    userStateDirty.frontEndInstructions.forwardCalls.phone &&
    !frontDeskValidState.forwardCalls.phone;

  const displayInvalidName =
    userStateDirty.frontEndInstructions.forwardCalls.name &&
    !frontDeskValidState.forwardCalls.name;

  return (
    <StyledSectionContainer>
      <LabelWrapper
        label={
          <TextContainer>
            <Text>Name</Text>
          </TextContainer>
        }
      >
        <Form.Item
          validateStatus={displayInvalidName ? 'error' : undefined}
          help={displayInvalidName ? ERROR_MESSAGES.name : undefined}
        >
          <InputNew
            value={name}
            onChange={handleNameChange}
            placeholder="Name"
            onBlur={() =>
              setUserStateDirty(prev => {
                const copy = { ...prev };
                copy.frontEndInstructions.forwardCalls.name = true;
                return copy;
              })
            }
          />
        </Form.Item>
      </LabelWrapper>
      <LabelWrapper
        label={
          <TextContainer>
            <Text>Phone</Text>
          </TextContainer>
        }
      >
        <Form.Item
          validateStatus={displayInvalidPhone ? 'error' : undefined}
          help={displayInvalidPhone ? ERROR_MESSAGES.mobile : undefined}
        >
          <InputNew
            value={phone}
            onChange={handleNumberChange}
            placeholder="Phone"
            onBlur={() =>
              setUserStateDirty(prev => {
                const copy = { ...prev };
                copy.frontEndInstructions.forwardCalls.phone = true;
                return copy;
              })
            }
          />
        </Form.Item>
      </LabelWrapper>
    </StyledSectionContainer>
  );
};

export default ForwardCalls;

const StyledSectionContainer = styled(SectionContainer)`
  padding-top: 24px;
`;
const TextContainer = styled.div`
  margin-bottom: 8px;
`;
